import { useEffect, useState } from 'react';

import Slider from 'antd/es/slider';

import formatPrice from '@utils/formatPrice';
import { getCurrencySymbol } from '@utils/utils';
import Price from '@components/ui/price';
import {
  WrapperStyled,
  SectionTitleStyled,
  Wrapper,
} from '@components/Slider/styled';

function formatCurrencyAsLiras(value: number) {
  return `${formatPrice(value)?.liras || 0} ${getCurrencySymbol('tl')}`;
}

export type PriceType = [number, number];

type PriceRangeSliderType = {
  min?: number;
  max?: number;
  values?: PriceType;
  onChange: (values: number[]) => void;
  title?: string;
};

export default function PriceRangeSlider({
  min = 1,
  max = 100000,
  values = [1, 10000],
  onChange,
  title = 'Fiyat Aralığı',
}: PriceRangeSliderType) {
  const [prices, setPrices] = useState<PriceType>(values);

  useEffect(() => {
    setPrices(values);
  }, [values]);

  return (
    <WrapperStyled>
      <SectionTitleStyled>{title}</SectionTitleStyled>
      {prices[0] && prices[1] ? (
        <Wrapper>
          <Price
            originalPrice={prices[0]}
            price={prices[0]}
            fontSize={14}
            showDecimal={false}
          />
          <Price
            originalPrice={prices[1]}
            price={prices[1]}
            fontSize={14}
            showDecimal={false}
          />
        </Wrapper>
      ) : null}
      <Slider
        range
        tooltip={{
          open: false,
          placement: 'bottom',
          formatter: (value) => formatCurrencyAsLiras(value || 0),
        }}
        step={1}
        defaultValue={values}
        min={min}
        max={max}
        onAfterChange={onChange}
        onChange={(value) => setPrices(value as PriceType)}
        value={prices}
      />
    </WrapperStyled>
  );
}
